// extracted by mini-css-extract-plugin
module.exports = {"sider":"sider-1virgu6n"};